import {
    IonBackButton,
    IonButtons,
    IonCol,
    IonContent,
    IonGrid,
    IonHeader,
    IonPage,
    IonRow,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findFileTypes } from "../../store/fileTypes/actions/findFileTypes";
import { selectFileTypes } from "../../store/fileTypes/selectors/selectFileTypes";
import { CreateFileTypeButton } from "./components/CreateFileTypeButton";
import { FileTypesListContainer } from "./components/FileTypesListContainer";
import { FileTypesSearchBar } from "./components/FileTypesSearchBar";
import { FilterChip } from "./components/FilterChip";
import { FilterSelector } from "./components/FilterSelector";

export const FileTypesList = () => {
    const fileTypesList = useSelector(selectFileTypes);
    const dispatch = useDispatch();

    useEffect(() => {
        if (fileTypesList.length === 0) {
            dispatch(findFileTypes());
        }
    }, [dispatch]);

    return (
        <IonPage>
            <IonHeader class="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton color="light" defaultHref="/app/tic" />
                    </IonButtons>
                    <IonTitle>Tipos de archivos</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                {/* <CreateFileTemplateButton /> */}
                <section className="ion-padding">
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <FileTypesSearchBar />
                                <FilterChip/>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <FileTypesListContainer />
                </section>
            </IonContent>
            <FilterSelector />
            <CreateFileTypeButton />
        </IonPage>
    );
}